<div class="w-100 h-100 justify-content-center align-items-center d-flex" [ngClass]="{'background-image': !isModal}">
    <div class="activate-location-container"
         [ngClass]="{'activate-location-container-font-color-white': !isModal, 'activate-location-container-font-color-black': isModal}">
        <div class=" d-flex" *ngIf="!isModal">
            <div class="logo-container">
                <img src="assets/images/icons/monex_login_icon.svg" alt="monex-icon">
            </div>
        </div>
        <div class="label-activate-container mt-3 mb-3 w-100 d-flex justify-content-center">
            {{ "geolocation.message" | translate }}
        </div>
        <div class="error-message w-100 " *ngIf="showErrorMessage && !isModal" >
            {{ "geolocation.errorMessage" | translate }}
        </div>
        <div class="table-container" *ngIf="!isModal">
            <table>
                <thead>
                <tr>
                    <th></th>
                    <th></th>
                </tr>
                </thead>
                <tbody>
                <tr *ngFor="let browser of browsers"
                    style="display: flex; align-items: center; margin-top:10px; cursor: pointer"
                    (click)="open(browser)">
                    <td style="width: 80px">
                        <a [href]="browser.url" target="_blank">{{ browser.name }} </a>
                    </td>
                    <td style="width: 100px">
                        <img style="width: 30px;margin-left: 10px" [src]="browser.icon" alt="monex">
                    </td>
                </tr>
                </tbody>
            </table>
        </div>
        <div class="activate-geo-label mt-4 font-weight-bold">
            {{ "geolocation.enableGeolocationLabel" | translate }}
        </div>
        <div class="activate-location-btn-container d-flex align-items-center">
            <button class="primary btn-primary mt-4 p-0" (click)="requestLocation()" style="width: 220px">
                <span *ngIf="!loading">{{ "geolocation.validateGeolocation" | translate }}</span>
                <span *ngIf="loading" class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>

            </button>
        </div>

    </div>
</div>



